module.exports = __webpack_public_path__ + "static/assets/47559aa9ab616a217b17a35a05b652e7.svg";